require('flexslider');

(function ($) {
	/**
	 * Background gallery slideshow.
	 */
	(function () {
		var total = 0,
			current = 0,
			context = $('#background-images .overlay');

		var infoSlider = $('#background-images .info-slider').flexslider({
			slideshow: false,
			startAt: parseInt($('#background-images ul').attr('data-start')),
			controlNav: false,
			directionNav: false,
			sync: imageSlider,
			useCss: false,
		});

		var imageSlider = $('#background-images .images').flexslider({
			slideshow: false,
			startAt: parseInt($('#background-images ul').attr('data-start')),
			controlNav: false,
			directionNav: true,
			/* controlsContainer: '#background-images .controls', */
			useCss: true,
			sync: '.info-slider',
			after: function (slider) {},
			before: function (slider) {
				current = slider.animatingTo;
				updateCounter();
				var field = $('#background-images .field-' + current);
				field.addClass('loaded');
				field.find('img').css('display', '');
			},
			start: function (slider) {
				current = slider.currentSlide;
				total = slider.count;
				updateCounter();

				$('.gallery-prev', context).on('click', function (e) {
					if (current - 1 < 0) {
						slider.flexAnimate(total - 1);
					} else {
						slider.flexAnimate(current - 1);
					}
					e.preventDefault();
				});

				$('.gallery-next', context).on('click', function (e) {
					if (current + 1 > total - 1) {
						slider.flexAnimate(0);
					} else {
						slider.flexAnimate(current + 1);
					}
					e.preventDefault();
				});
			},
		});

		function updateCounter() {
			$('span.count', context).text(current + 1);
			$('span.total', context).text(total);
		}

		$('#background-images .info-toggle').on('click', function (e) {
			$('body').toggleClass('gallery-info-open');
			e.preventDefault();
		});
	})();

	$('#mobile-navigation').attr('aria-hidden', 'true');
	$('#mobile-navigation a').attr('tabindex', '-1');

	$('.nav-toggle').on('click', function (e) {
		$('body').toggleClass('nav-open');

		var nav = $('#mobile-navigation');
		if ($('body').hasClass('nav-open')) {
			$(this)
				.attr('aria-expanded', 'true')
				.attr('aria-label', shuStrings.hideMenu);

			nav.attr('aria-hidden', 'false');
			$('#mobile-navigation a').removeAttr('tabindex');
		} else {
			$(this)
				.attr('aria-expanded', 'false')
				.attr('aria-label', shuStrings.showMenu);

			nav.attr('aria-hidden', 'true');
			$('#mobile-navigation a').attr('tabindex', '-1');
		}
		e.preventDefault();
	});

	$('#mobile-navigation a').on('click', function () {
		$('body').toggleClass('nav-open');
	});

	$('.gallery-toggle').on('click', function (e) {
		$('body').toggleClass('gallery-open');
		$('body').removeClass('gallery-info-open');
		e.preventDefault();
	});

	/**
	 * Lazyloading of images.
	 */
	// (function () {
	// 	$('img.lazyload').lazy({
	// 		delay: 300,
	// 		effect: 'fadeIn',
	// 		effectTime: 1500,
	// 	});
	// })();

	/**
	 * Event tracking
	 */
	// $('#shcustom-bookingmask-form').on('submit', function () {
	// 	if (window.ga && typeof window.ga === 'function') {
	// 		window.ga('send', 'event', 'Book Room', 'Open');
	// 	}
	// });
	// $('.body a.fancybox[href*="gotthardskrog.2book.se"]').on(
	// 	'click',
	// 	function () {
	// 		if (window.ga && typeof window.ga === 'function') {
	// 			window.ga('send', 'event', 'Book Table', 'Open', 'Link in text');
	// 		}
	// 	},
	// );
})(jQuery);
